import React, { memo } from 'react';
import { DollarSignIcon, ClockIcon, KeyIcon, CalendarIcon, HeartIcon } from 'lucide-react';
export const WhyJoin = () => {
  return <section id="why-join" className="py-24 bg-white" data-id="element-816">
      <div className="container mx-auto px-6" data-id="element-817">
        <div className="text-center mb-16" data-id="element-818">
          <h2 className="text-5xl font-serif font-bold mb-6 text-gray-800" data-id="element-819">
            Why Join The Elite Planners Association
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-820">
            Join an exclusive network of top South Asian wedding planners and
            elevate your business to new heights.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8" data-id="element-821">
          <div className="bg-limestone-50 p-10 rounded-lg shadow-sm text-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-822">
            <div className="flex justify-center mb-6" data-id="element-823">
              <div className="p-3 rounded-full bg-white shadow-sm" data-id="element-824">
                <DollarSignIcon className="h-8 w-8 text-limestone-700" data-id="element-825" />
              </div>
            </div>
            <h3 className="text-xl font-serif font-bold mb-4 text-gray-800" data-id="element-826">
              Earn More
            </h3>
            <p className="text-gray-600" data-id="element-827">
              Increase your revenue with exclusive destination wedding
              commissions and premium vendor partnerships.
            </p>
          </div>
          <div className="bg-limestone-50 p-10 rounded-lg shadow-sm text-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-828">
            <div className="flex justify-center mb-6" data-id="element-829">
              <div className="p-3 rounded-full bg-white shadow-sm" data-id="element-830">
                <ClockIcon className="h-8 w-8 text-limestone-700" data-id="element-831" />
              </div>
            </div>
            <h3 className="text-xl font-serif font-bold mb-4 text-gray-800" data-id="element-832">
              Save Time
            </h3>
            <p className="text-gray-600" data-id="element-833">
              Access streamlined workflows, vendor connections, and planning
              tools that save you hundreds of hours each year.
            </p>
          </div>
          <div className="bg-limestone-50 p-10 rounded-lg shadow-sm text-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-834">
            <div className="flex justify-center mb-6" data-id="element-835">
              <div className="p-3 rounded-full bg-white shadow-sm" data-id="element-836">
                <KeyIcon className="h-8 w-8 text-limestone-700" data-id="element-837" />
              </div>
            </div>
            <h3 className="text-xl font-serif font-bold mb-4 text-gray-800" data-id="element-838">
              Exclusive Access
            </h3>
            <p className="text-gray-600" data-id="element-839">
              Gain privileged access to luxury venues, special rates, and
              insider connections unavailable to non-members.
            </p>
          </div>
          <div className="bg-limestone-50 p-10 rounded-lg shadow-sm text-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-840">
            <div className="flex justify-center mb-6" data-id="element-841">
              <div className="p-3 rounded-full bg-white shadow-sm" data-id="element-842">
                <CalendarIcon className="h-8 w-8 text-limestone-700" data-id="element-843" />
              </div>
            </div>
            <h3 className="text-xl font-serif font-bold mb-4 text-gray-800" data-id="element-844">
              Annual Gala
            </h3>
            <p className="text-gray-600" data-id="element-845">
              Network at our luxurious annual gala with top industry
              professionals, creating valuable connections and memories.
            </p>
          </div>
          <div className="bg-limestone-50 p-10 rounded-lg shadow-sm text-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-846">
            <div className="flex justify-center mb-6" data-id="element-847">
              <div className="p-3 rounded-full bg-white shadow-sm" data-id="element-848">
                <HeartIcon className="h-8 w-8 text-limestone-700" data-id="element-849" />
              </div>
            </div>
            <h3 className="text-xl font-serif font-bold mb-4 text-gray-800" data-id="element-850">
              Lifestyle
            </h3>
            <p className="text-gray-600" data-id="element-851">
              Enjoy a more balanced lifestyle with destination weddings that
              combine work with travel to luxury resorts and beautiful
              locations.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-852">
          <a href="#calculator" className="text-limestone-700 font-medium hover:text-limestone-800 flex items-center justify-center" data-id="element-853">
            <span data-id="element-854">See how much more you could earn</span>
            <svg className="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-855">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-856"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>;
};